import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/centroCusto' };
/////////////////////////////////////////////////////////////////////////////////

export function createCentroCustoCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateCentroCustoCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listCentroCustoCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findCentroCustoCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllCentroCustoCadastro() {
  return httpService.get({ ...args, path: '/centroCusto/all' });
}

export function deleteCentroCustoCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

